import React, {useEffect} from "react";
import {refreshToken} from "@ekultur/authentication";
import {useAuthsDispatch, USER_LOGGED_IN} from "./authsContext";
import {useLocation} from "react-router";

const rootStyle = {height: "100vh", overflowY: "hidden", overflowX: "hidden"};

/**
 * Higher-order component that wraps the children with a useEffect that attempts to
 * log the user in by refreshing the token, if the user is not already logged in.
 */
export const WithAuthentication = ({children}) => {
    const location = useLocation();
    const dispatch = useAuthsDispatch();

    useEffect(() => {
        if (!location.pathname.startsWith("/oauth2/callback")) {
            refreshToken({
                apiGateway: window._env_.REACT_APP_API_GATEWAY,
                onSuccess: () => dispatch({type: USER_LOGGED_IN}),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div style={rootStyle}>{children}</div>;
};
